// src/components/ui/PasswordRequirements.jsx
import React from 'react';
import { Check, X } from 'lucide-react';

// Mirrors backend app/password_policy.py (length + complexity).
// The common-password and email-name checks are server-side only and
// surface as a submit error, since shipping the blocklist to the browser
// isn't practical. Keep MIN_LENGTH in sync with the backend.
const MIN_LENGTH = 12;
const SPECIAL = /[!@#$%^&*()_+\-=[\]{}|;:'",.<>/?`~\\]/;

export const PASSWORD_RULES = [
  { id: 'len',     label: `At least ${MIN_LENGTH} characters`, test: (p) => p.length >= MIN_LENGTH },
  { id: 'upper',   label: 'One uppercase letter',             test: (p) => /[A-Z]/.test(p) },
  { id: 'lower',   label: 'One lowercase letter',             test: (p) => /[a-z]/.test(p) },
  { id: 'number',  label: 'One number',                       test: (p) => /\d/.test(p) },
  { id: 'special', label: 'One special character',            test: (p) => SPECIAL.test(p) },
];

// Returns true if all client-checkable rules pass.
export function passwordMeetsRules(password) {
  return PASSWORD_RULES.every((r) => r.test(password || ''));
}

export default function PasswordRequirements({ password = '', className = '' }) {
  return (
    <ul className={`mt-2 space-y-1 ${className}`} aria-label="Password requirements">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password);
        return (
          <li key={rule.id} className="flex items-center gap-2 text-xs">
            {met ? (
              <Check className="h-3.5 w-3.5 text-green-500 shrink-0" aria-hidden />
            ) : (
              <X className="h-3.5 w-3.5 text-gray-500 shrink-0" aria-hidden />
            )}
            <span className={met ? 'text-green-400' : 'text-gray-400'}>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}